var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tomain"}},[_c('Navbar',{staticClass:"Bavbar-item"}),_c('app-main',{staticClass:"Main-item"}),_c('Footer',{staticClass:"Footer-item"}),_c('BackTop',{staticClass:"BackTop-item"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }